import React from "react";

export const Head = () => {
  return (
    <header id="heading">
      <h1>Sorting Algorithm Visualiser</h1>
    </header>
  );
};
